import classNames from 'classnames';
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from 'react';
import { TABLE_WIDTH } from 'src/constants/common';

import { FormatsMenu } from '../FormatsMenu';
import { RubricsMenu } from '../RubricsMenu';

import { BottomMenu } from './components/BottomMenu';
import { checkSpaceMenuRubricFromBottom, useMutationObserverMenu } from './helpers/viewMenu';
import styles from './left-column.module.scss';

interface LeftColumnContentProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const LeftColumnContent = ({ subscriptionPopupState }: LeftColumnContentProps) => {
  const {
    query: { rubric, organizationAlias },
  } = useRouter();

  const formatsRef = useRef<HTMLDivElement>();
  const rubricsRef = useRef<HTMLDivElement>();
  const linksRef = useRef<HTMLDivElement>();
  const menuWrapperRef = useRef<HTMLDivElement>();

  const [isShowBottomMenu, setIsShowBottomMenu] = useState(false);

  const isPartnersNews = Boolean(organizationAlias) || rubric === 'novosti-partnerov';

  useMutationObserverMenu(
    menuWrapperRef,
    linksRef,
    () => {
      const windowInnerWidth = window.innerWidth;
      if (windowInnerWidth >= TABLE_WIDTH) {
        const res = checkSpaceMenuRubricFromBottom(menuWrapperRef, linksRef, isPartnersNews);
        setIsShowBottomMenu(res);
      }
    },
    () => {
      const res = checkSpaceMenuRubricFromBottom(menuWrapperRef, linksRef, isPartnersNews, true);
      setIsShowBottomMenu(res);
    },
  );

  useEffect(() => {
    const checkWindowHeight = () => {
      const windowInnerWidth = window.innerWidth;
      if (windowInnerWidth >= TABLE_WIDTH) {
        const res = checkSpaceMenuRubricFromBottom(menuWrapperRef, linksRef, isPartnersNews);
        setIsShowBottomMenu(res);
      }
    };

    const checkWindowHeightResize = () => {
      const windowInnerWidth = window.innerWidth;
      if (windowInnerWidth >= TABLE_WIDTH) {
        const res = checkSpaceMenuRubricFromBottom(menuWrapperRef, linksRef, isPartnersNews, true);
        setIsShowBottomMenu(res);
      }
    };

    checkWindowHeight();

    window.addEventListener('resize', checkWindowHeightResize);

    return () => {
      window.removeEventListener('resize', checkWindowHeightResize);
    };
  }, [isPartnersNews]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.stickyBlock}>
        <div className={styles.menuWrapper} ref={menuWrapperRef}>
          <div ref={formatsRef}>
            <FormatsMenu />
          </div>
          <div ref={rubricsRef} className={classNames(styles.rubricsBlock, styles[`rubricsBlock--visible`])}>
            {!isPartnersNews && <RubricsMenu subscriptionPopupState={subscriptionPopupState} />}
          </div>
        </div>
        <div
          ref={linksRef}
          className={classNames('h-mb-24', styles.linkWrapper, { [styles['linkWrapper--visible']]: isShowBottomMenu })}
        >
          <BottomMenu subscriptionPopupState={subscriptionPopupState} />
        </div>
      </div>
    </div>
  );
};
